import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  suffix?: string;
  type?: 'text' | 'number' | 'date';
  value: string;
  placeholder?: string;
  min?: string;
  max?: string;
  onChange: (value: string) => void;
}
export function Field({
  id,
  label,
  required,
  error,
  hint,
  suffix,
  type = 'text',
  value,
  placeholder,
  min,
  max,
  onChange
}: FieldProps) {
  const describedBy = [hint ? `${id}-hint` : null, error ? `${id}-error` : null].filter(Boolean).join(' ');
  return <div data-id="element-78" data-mp="hti5vfgnudn0">
      <label htmlFor={id} className="block text-[12px] font-semibold text-ink-700" data-id="element-79" data-mp="hutcdn1hpzht">
        {required && <span className="mr-0.5 text-danger-fg" aria-hidden="true" data-id="element-80" data-mp="mscyf94fjgkb">
            *
          </span>}
        {label}
      </label>
      <div className="relative mt-1" data-id="element-81" data-mp="wr25s7yp9imb">
        <input id={id} type={type} value={value} min={min} max={max} placeholder={placeholder} required={required} aria-invalid={error ? true : undefined} aria-describedby={describedBy || undefined} onChange={event => onChange(event.target.value)} className={`h-9 w-full rounded border bg-white px-2.5 text-[13px] tabular-nums text-ink-900 placeholder:text-ink-400 transition-colors duration-150 ease-out focus:border-leaf-600 ${suffix ? 'pr-8' : ''} ${error ? 'border-danger-fg' : 'border-line-strong hover:border-ink-400'}`} data-id="element-82" data-mp="ws3u3e4q81lz" />
        {suffix && <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[13px] text-ink-400" aria-hidden="true" data-id="element-83" data-mp="17bcf50w2n43t">
            {suffix}
          </span>}
      </div>
      {hint && !error && <p id={`${id}-hint`} className="mt-1 text-[11px] leading-snug text-ink-500" data-id="element-84" data-mp="1zu9q83w44qal">
          {hint}
        </p>}
      {error && <p id={`${id}-error`} className="mt-1 flex items-start gap-1 text-[11px] font-medium leading-snug text-danger-fg" data-id="element-85" data-mp="3p9anie9ur1v2">
          <AlertCircleIcon className="mt-px h-3 w-3 shrink-0" aria-hidden="true" data-id="element-86" data-mp="3uahu4a09dv05" />
          {error}
        </p>}
    </div>;
}